var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgLogoSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 25 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logoSmall_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.763 21.27v-9.253H.92V7.025h1.844V1.322L9.231 0v7.025h5.462v4.992h-5.46v7.975a2.534 2.534 0 0 0 .612 1.923c.61.43 1.354.627 2.097.557.366 0 .73-.026 1.092-.076.51-.088 1.014-.208 1.508-.361v5.225c-.714.214-1.445.367-2.185.459-.752.115-1.511.178-2.272.188a7.964 7.964 0 0 1-5.463-1.682 6.27 6.27 0 0 1-1.859-4.955Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.326 20.472a3.353 3.353 0 0 1 2.535 1.092 3.903 3.903 0 0 1 0 5.342A3.388 3.388 0 0 1 21.326 28a3.442 3.442 0 0 1-2.556-1.093 3.834 3.834 0 0 1 0-5.341 3.42 3.42 0 0 1 2.556-1.094Z",
  fill: "#D80073"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "logoSmall_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.919)",
  d: "M0 0h24v28H0z"
})))));

export default SvgLogoSmall;